import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { getUserLocal } from "utils/localStorage.util";
import { getFirstAllowedRoute, hasPermission } from "utils/permission.util";

const PermissionGuard = ({ children, permission }) => {
  const user = getUserLocal();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (!hasPermission(permission, user)) {
    return <Navigate to={getFirstAllowedRoute(user)} replace />;
  }

  return children;
};

PermissionGuard.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.string,
};

export default PermissionGuard;
